// import InputNumber from "#common/input/InputNumber"
import PERMISOS from "#constants/perfiles"
import InputNumber from "#core/components/input/number/InputNumber"
import { UseHasPermission } from "#hooks/useHasPermission"
import TrendingUpIcon from "@mui/icons-material/TrendingUp"
import { Box, Button, Divider, InputAdornment, Paper, Typography } from "@mui/material"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

export default function Kpis({ kpis = [], valueK, setValueK, perfilPuesto }) {
	// const [valueK, setValueK] = useState({})

	const kpiValues = useCallback(
		(id) => {
			return {
				value: valueK[id],
				setValue: (v) => {
					setValueK((prev) => ({
						...prev,
						[id]: v,
					}))

					if (v > 100) {
						toast.error("El valor no puede ser mayor a 100%")
					}
					if (v < 0) {
						toast.error("El valor no puede ser menor a 0%")
					}
				},
			}
		},
		[setValueK, valueK],
	)
	if (kpis.length === 0) return <EvaluationKpisNotFound perfilPuesto={perfilPuesto} />
	const items = kpis.map((kpi) => <Kpi key={kpi.id} kpi={kpi} {...kpiValues(kpi.id)} />)
	return (
		<Box sx={{ p: 2 }}>
			<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>{items}</Box>
		</Box>
	)
}

const Kpi = ({ kpi, value, setValue }) => {
	return (
		<Paper
			elevation={1}
			sx={{
				p: 2.5,
				borderRadius: 2,
				border: "1px solid",
				borderColor: "divider",
				transition: "all 0.3s ease",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
				{/* Contenido del KPI */}
				<Box sx={{ flexGrow: 1 }}>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
						<TrendingUpIcon sx={{ color: "primary.main", fontSize: 20 }} />
						<Typography
							variant="subtitle1"
							sx={{
								fontWeight: 600,
								color: "text.primary",
							}}
						>
							{kpi.name}
						</Typography>
					</Box>

					{kpi.description && (
						<Typography
							variant="body2"
							sx={{
								color: "text.secondary",
								lineHeight: 1.6,
								pl: 3.5,
							}}
						>
							{kpi.description}
						</Typography>
					)}
				</Box>

				{/* Divider vertical */}
				<Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

				{/* Input para el porcentaje */}
				<Box
					sx={{
						width: "15%",
						minWidth: "120px",
						flexShrink: 0,
					}}
				>
					<InputNumber
						label="Porcentaje"
						startAdornment={<InputAdornment position="start">%</InputAdornment>}
						value={value}
						setValue={setValue}
					/>
				</Box>
			</Box>
		</Paper>
	)
}

const EvaluationKpisNotFound = ({ perfilPuesto }) => {
	const navigate = useNavigate()
	const isRh = UseHasPermission(PERMISOS.RH)
	if (!isRh)
		return (
			<Box sx={{ textAlign: "center", p: 2 }}>
				<Typography variant="h5">No hay Categorías disponibles</Typography>
				<Typography variant="h5">Por favor comunicado al equipo de RH</Typography>
			</Box>
		)
	return (
		<Box sx={{ textAlign: "center", p: 2 }}>
			<Typography variant="h5">No hay Categorías Kpi disponibles</Typography>
			<Button sx={{ mt: 2 }} onClick={() => navigate(`../perfil-puesto/${perfilPuesto}`)}>
				Ir al perfil de puesto
			</Button>
		</Box>
	)
}
